// extracted by mini-css-extract-plugin
export default {"page":"SyllabusViewPage_page__9vyRw","loaderWrap":"SyllabusViewPage_loaderWrap__t7+La","empty":"SyllabusViewPage_empty__BcgsN","content":"SyllabusViewPage_content__KMNyH"};